// Layer drawer: one toggle per drawable layer, and a legend row under each layer that is on.
// Every row's title, attribution, licence and as-of come from the manifest entry (design D4).

import { h, link, provenance } from "./dom";
import type { StyledLayer } from "./manifest";

export function renderDrawer(container: HTMLElement, layers: StyledLayer[], visible: ReadonlySet<string>, onToggle: (id: string, on: boolean) => void): void {
  const list = h("ul", { class: "layers" });
  for (const { entry, style } of layers) {
    const on = visible.has(entry.id);
    const input = h("input", { type: "checkbox", id: `toggle-${entry.id}`, "data-layer": entry.id });
    input.checked = on;
    input.addEventListener("change", () => onToggle(entry.id, input.checked));

    const row = h("li", { class: "layer", "data-layer": entry.id }, h("label", { for: input.id }, input, h("span", { class: "layer-title" }, entry.title)));
    if (on) {
      const classes = h("ul", { class: "classes" });
      for (const c of style.legend) {
        classes.append(h("li", {}, h("span", { class: "swatch", style: `--swatch:${c.color}`, "aria-hidden": "true" }), c.label));
      }
      const legend = h("div", { class: "legend", "data-legend": entry.id }, classes, provenance(entry));
      if (style.links?.length) legend.append(h("p", { class: "official" }, ...style.links.flatMap((l, i) => [i ? " · " : "", link(l.href, l.label)])));
      row.append(legend);
    }
    list.append(row);
  }
  container.replaceChildren(list);
}
